import creditEngineRepository, { CreditEngineRepository } from "./CreditEngineRepository";

const APPLICATION_JSON = "application/json";

const resource = "/office";
export default {
  getPartnerDetailsFromOfficeId(officeId) {
    creditEngineRepository.setContentType(APPLICATION_JSON);
    return CreditEngineRepository.get(`${resource}/${officeId}/partnerName`);
  },

  getRetailerDetailsFromExternalId(externalId) {
    creditEngineRepository.setContentType(APPLICATION_JSON);
    return CreditEngineRepository.get(`${resource}/externalId/${externalId}/retailerName`);
  },

  getRetailerDetailsFromOfficeId(officeId) {
    creditEngineRepository.setContentType(APPLICATION_JSON);
    return CreditEngineRepository.get(`${resource}/${officeId}/retailerName`);
  }  
};
